import { Link } from 'react-router-dom';
import { ArrowRight } from '@phosphor-icons/react';

import { Button } from '../ui/Button';
import { LandingRiskLine } from './LandingRiskLine';
import { ScrollReveal } from './ScrollReveal';
import pt from '../../locales/pt';

const sectionInner = 'mx-auto w-full max-w-[1120px]';

/**
 * section/final-cta (.pen) — reutilizado na Landing e em About.
 */
export function FinalCta() {
  return (
    <section className="bg-sage-50 px-space-5 py-space-16 text-center dark:bg-sage-900/40 mid:px-space-10 mid:py-space-16 wide:px-space-20 wide:py-space-24">
      <ScrollReveal scale={0.96} className={`${sectionInner} flex flex-col items-center gap-space-8`}>
        <h2 className="type-landing-h2 mx-auto max-w-[18ch]">{pt.landing.finalCta.title}</h2>
        <div className="flex flex-col items-center gap-space-3">
          <Link to="/sign-up" className="inline-block">
            <Button
              size="lg"
              className="h-14 gap-space-2 rounded-ds-full px-space-8 text-type-display-stat shadow-[0_16px_30px_-14px_rgba(95,126,84,0.6)]"
            >
              {pt.landing.hero.cta}
              <ArrowRight className="h-5 w-5" aria-hidden />
            </Button>
          </Link>
          <LandingRiskLine className="justify-center" />
        </div>
      </ScrollReveal>
    </section>
  );
}
